// @flow

// Actions
export const FETCH_SOIL_JOBS = '@@hfty-soil-jobs/FETCH_SOIL_JOBS'
export const SELECT_SOIL_JOB = '@@hfty-soil-jobs/SELECT_SOIL_JOB'
export const FILTER_BY_STATUS = '@@hfty-soil-jobs/FILTER_BY_STATUS'
export const FILTER_BY_DATE_RANGE = '@@hfty-soil-jobs/FILTER_BY_DATE_RANGE'
export const FILTER_BY_ASSIGN_TO = '@@hfty-soil-jobs/FILTER_BY_ASSIGN_TO'
export const FILTER_BY_SEASON = '@@hfty-soil-jobs/FILTER_BY_SEASON'
export const IMPORT_JOBS = '@@hfty-soil-jobs/IMPORT_JOBS'

// State Configuration
export const TREE = 'soilJobData'
export const BRANCH = 'soilJobs'
export const POINTS_BRANCH = 'soilPoints'
export const GRIDS_BRANCH = 'grids'
